module.exports = "pegasus/assets/themelp1/large/1.png";